"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "sheet"
  }, [_c("header", {
    staticClass: "head"
  }, [_c("h1", [_vm._v("Espelho de Ponto")]), _vm._v(" "), _c("div", {
    staticClass: "period"
  }, [_c("strong", [_vm._v("Competência:")]), _vm._v(" " + _vm._s(_vm.formatMonthAndYear(_vm.startDate)) + "\n      "), _c("span", {
    staticClass: "sep"
  }, [_vm._v("|")]), _vm._v(" "), _c("strong", [_vm._v("Período de Competência:")]), _vm._v(" " + _vm._s(_vm.formatDate(_vm.startDate)) + " -\n      " + _vm._s(_vm.formatDate(_vm.endDate)) + "\n    ")]), _vm._v(" "), _c("hr")]), _vm._v(" "), _c("section", {
    staticClass: "info"
  }, [_c("div", {
    staticClass: "row"
  }, [_c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("Empresa:")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.farm.name))])]), _vm._v(" "), _c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("CNPJ:")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.farm.cnpj))])])]), _vm._v(" "), _c("div", {
    staticClass: "row"
  }, [_c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("Funcionário(a):")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c("div", {
    staticClass: "row"
  }, [_c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("CPF:")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.cpf))])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c("section", {
    staticClass: "schedule"
  }, [_c("h2", [_vm._v("HORÁRIO DE TRABALHO")]), _vm._v(" "), _c("div", {
    staticClass: "grid-2"
  }, [_c("div", {
    staticClass: "col"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("span", {
    staticClass: "day"
  }, [_vm._v("Escala:")]), _vm._v(" "), _c("span", {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.shiftHours.title))])]), _vm._v(" "), _c("div", {
    staticClass: "item"
  }, [_c("span", {
    staticClass: "day"
  }, [_vm._v("Início do turno:")]), _vm._v(" "), _c("span", {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.shiftHours.start)))])]), _vm._v(" "), _c("div", {
    staticClass: "item"
  }, [_c("span", {
    staticClass: "day"
  }, [_vm._v("Término do turno:")]), _vm._v(" "), _c("span", {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.shiftHours.end)))])]), _vm._v(" "), _c("div", {
    staticClass: "item"
  }, [_c("span", {
    staticClass: "day"
  }, [_vm._v("Dias da semana:")]), _vm._v(" "), _c("span", {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.formatWeekdays(_vm.shiftHours.weekdays)))])])]), _vm._v(" "), _c("div", {
    staticClass: "col"
  }, _vm._l(_vm.shiftHours.breaks, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "item"
    }, [_c("span", {
      staticClass: "day"
    }, [_vm._v(_vm._s(item.title) + ": ")]), _c("span", {
      staticClass: "day"
    }, [_vm._v(_vm._s(item.start))]), _vm._v(" -\n          "), _c("span", {
      staticClass: "day"
    }, [_vm._v(_vm._s(item.end))])]);
  }), 0)])]), _vm._v(" "), _c("section", {
    staticClass: "records"
  }, [_c("table", {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c("tbody", _vm._l(_vm.timesheetsDaily, function (item, idx) {
    var _item$attendances$, _item$attendances$$pu, _item$attendances$2, _item$attendances$2$p, _item$attendances$3, _item$attendances$3$p, _item$attendances$4, _item$attendances$4$p, _item$attendances$5, _item$attendances$5$p, _item$attendances$6, _item$attendances$6$p;
    return _c("tr", {
      key: idx
    }, [_c("td", {
      staticClass: "sticky"
    }, [_vm._v("\n            " + _vm._s(_vm.formatDateWeek(item.date)) + "\n          ")]), _vm._v(" "), _c("td", [_vm._v(_vm._s(_vm.formatTime((_item$attendances$ = item.attendances[0]) === null || _item$attendances$ === void 0 ? void 0 : (_item$attendances$$pu = _item$attendances$.punchIn) === null || _item$attendances$$pu === void 0 ? void 0 : _item$attendances$$pu.clockedAt)))]), _vm._v(" "), _c("td", [_vm._v(_vm._s(_vm.formatTime((_item$attendances$2 = item.attendances[0]) === null || _item$attendances$2 === void 0 ? void 0 : (_item$attendances$2$p = _item$attendances$2.punchOut) === null || _item$attendances$2$p === void 0 ? void 0 : _item$attendances$2$p.clockedAt)))]), _vm._v(" "), _c("td", [_vm._v(_vm._s(_vm.formatTime((_item$attendances$3 = item.attendances[1]) === null || _item$attendances$3 === void 0 ? void 0 : (_item$attendances$3$p = _item$attendances$3.punchIn) === null || _item$attendances$3$p === void 0 ? void 0 : _item$attendances$3$p.clockedAt)))]), _vm._v(" "), _c("td", [_vm._v(_vm._s(_vm.formatTime((_item$attendances$4 = item.attendances[1]) === null || _item$attendances$4 === void 0 ? void 0 : (_item$attendances$4$p = _item$attendances$4.punchOut) === null || _item$attendances$4$p === void 0 ? void 0 : _item$attendances$4$p.clockedAt)))]), _vm._v(" "), _c("td", [_vm._v(_vm._s(_vm.formatTime((_item$attendances$5 = item.attendances[2]) === null || _item$attendances$5 === void 0 ? void 0 : (_item$attendances$5$p = _item$attendances$5.punchIn) === null || _item$attendances$5$p === void 0 ? void 0 : _item$attendances$5$p.clockedAt)))]), _vm._v(" "), _c("td", [_vm._v(_vm._s(_vm.formatTime((_item$attendances$6 = item.attendances[2]) === null || _item$attendances$6 === void 0 ? void 0 : (_item$attendances$6$p = _item$attendances$6.punchOut) === null || _item$attendances$6$p === void 0 ? void 0 : _item$attendances$6$p.clockedAt)))]), _vm._v(" "), _c("td", {
      class: {
        neg: item.balance && item.balance < 0
      }
    }, [_vm._v("\n            " + _vm._s(_vm.formatSeconds(item.balance)) + "\n          ")])]);
  }), 0)])])]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("CTPS:")]), _c("span", {
    staticClass: "value"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "row"
  }, [_c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("Setor:")]), _c("span", {
    staticClass: "value"
  })]), _vm._v(" "), _c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("Cargo:")]), _c("span", {
    staticClass: "value"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("thead", [_c("tr", [_c("th", {
    staticClass: "sticky"
  }, [_vm._v("\n            Dia\n          ")]), _vm._v(" "), _c("th", [_vm._v("E1")]), _vm._v(" "), _c("th", [_vm._v("S1")]), _vm._v(" "), _c("th", [_vm._v("E2")]), _vm._v(" "), _c("th", [_vm._v("S2")]), _vm._v(" "), _c("th", [_vm._v("E3")]), _vm._v(" "), _c("th", [_vm._v("S3")]), _vm._v(" "), _c("th", [_vm._v("Jornada"), _c("br"), _vm._v("Total")]), _vm._v(" "), _c("th", [_vm._v("Saldo do dia")])])]);
}];
render._withStripped = true;